export default __webpack_public_path__ + "static/media/garbage.3e6ec578.png";